import { render, staticRenderFns } from "./homeCall.vue?vue&type=template&id=c7ce1d76&scoped=true&"
import script from "./homeCall.vue?vue&type=script&lang=js&"
export * from "./homeCall.vue?vue&type=script&lang=js&"
import style0 from "./homeCall.vue?vue&type=style&index=0&id=c7ce1d76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ce1d76",
  null
  
)

export default component.exports